import {ApolloClient, InMemoryCache} from "@apollo/client";
export const GRAPHQL_CLIENT =new ApolloClient({
    uri: 'http://localhost:5000/graphql',
    cache: new InMemoryCache(),
});